<template>
  <div>
    <v-expansion-panel-header color="accent" class="subtitle-1">
      {{ title }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mb-0 pb-0">
      <v-form ref="form">
        <v-row class="mt-3">
          <v-col
            :cols="title == 'Size' && showUnisex ? 5 : 12"
            class="ma-0 pa-0"
          >
            <v-jsf v-model="model" :schema="schema" @change="toggledForm" />
          </v-col>
          <v-divider vertical v-if="showUnisex"></v-divider>
          <v-col cols="7" v-if="showUnisex" class="ma-0 pa-0">
            <v-jsf
              @change="toggledForm"
              v-model="modelUnisex"
              :schema="schemaUnisex"
            />
          </v-col>
          <v-col
            cols="3"
            v-if="categoryImg != '' && title == 'Measurements'"
            class="ma-0 pa-0"
          >
            <expandable-image :src="categoryImg"> </expandable-image>
          </v-col>
        </v-row>
      </v-form>
    </v-expansion-panel-content>
  </div>
</template>

<script>
import VJsf from "@koumoul/vjsf/lib/VJsf.js";
import "@koumoul/vjsf/lib/VJsf.css";
import "@koumoul/vjsf/lib/deps/third-party.js";
export default {
  name: "DynamicFields",
  components: {
    VJsf,
  },
  props: {
    title: String,
    values: Object,
    config: Array,
    fillDynamic: Boolean,
    dialogTitle: String,
    categoryImg: String,
    gender: String,
    category: String,
  },
  data: () => ({
    model: {},
    schema: {},
    properties: {},
    show: false,
    showUnisex: false,
    modelUnisex: {},
    schemaUnisex: {},
    showImage: false,
  }),
  async mounted() {
    await this.formatFields();
    //if title is measurement then show measurements photo
    if (this.title == "Measurement") {
      this.showImage = true;
    }
  },
  methods: {
    toggledForm() {
      this.$emit("toggledDynamicFields");
    },
    // readOnly() {
    //   if (this.title == "Size")
    //     if (this.showUnisex) {
    //       // this.showUnisex = false;
    //       this.schemaUnisex["x-options"] = { disableAll: true };
    //     }
    //   // this.showUnisex = true;
    // },
    // logEvent(key, $event) {
    //   // console.log("vjsf key", key);
    //   console.log("vjsf event", $event);
    //   if (this.title == "Size")
    //     if (this.showUnisex) {
    //       if (key == "change") {
    //         console.log(this.schemaUnisex, "aha");
    //         for (let [key, value] of Object.entries(
    //           this.schemaUnisex.properties
    //         )) {
    //           console.log(key);
    //           value["readOnly"] = true;
    //         }
    //       }
    //     }
    // },
    // getId() {
    //   console.log(this.model);
    //   for (let [key, value] of Object.entries(this.schema.properties)) {
    //     console.log(key, value);
    //     console.log(document.getElementById(key));
    //   }
    // },
    //format schema fields
    async formatFields() {
      this.showUnisex = false;
      let requiredFields = [];
      for (let configuration of this.config) {
        let name = configuration.name;
        let title = configuration.name;
        if (configuration.representation) {
          title = `${configuration.name} (${configuration.representation})`;
        }
        let type = configuration.fieldType.toLowerCase();
        let tempObj = {
          type: type,
          name: name,
          title: title,
          // readOnly: true,
          "x-cols": 3,
          "x-style": "margin-right: 30px; ",
          "x-props": {
            outlined: true,
            dense: true,
            color: "accent",
          },
        };
        if (type == "select") {
          tempObj["enum"] = configuration.selectValues;
        }
        this.properties[name] = tempObj;
        this.model[name] = "";
        this.schema["type"] = "object";
        this.schema["properties"] = this.properties;
        if (configuration.required) {
          requiredFields.push(name);
        }
      }
      this.schema["required"] = requiredFields;
      //if gender unisex, then duplicate fields
      if (this.gender == "Unisex") {
        this.genderUnisex();
      }
      //if fillDynamic prop is true, then fill fields
      if (this.fillDynamic) {
        this.fillDynamicFields(
          this.values,
          this.schema,
          this.model,
          this.config
        );
        if (this.gender == "Unisex") {
          await this.fillDynamicFields(
            this.values,
            this.schemaUnisex,
            this.modelUnisex,
            this.config
          );
        }
      }
      //if fillDynamic is false, still fill in Other fields:
      if (this.title == "Other") {
        await this.fillDynamicFields(this.values, this.schema, this.model);
      }
      this.show = true;
    },
    async fillDynamicFields(values, schema, model, config) {
      if (this.title == "Measurements") {
        if (config) {
          config = config.map((el) => {
            let nameWithRep = `${el.name} (${el.representation})`;
            let obj = {};
            if (el.representation) {
              obj = { [nameWithRep]: el.name };
            } else {
              obj = { [el.name]: el.name };
            }
            return obj;
          });
        }
        //values gali būti arba tik žodžiai, arba žodžiai ir representation'ai
        //if there are any values
        if (values) {
          //key1 - reikšmės pavadinimas
          //key - formos laukelio pavadinimas
          if (config) {
            for (const [key1, value1] of Object.entries(values)) {
              let found = config.find(
                (el) =>
                  Object.keys(el)[0] == key1 || Object.values(el)[0] == key1
              );
              if (found) {
                model[Object.values(found)[0]] = value1;
              }
            }
          }
        }
      } else {
        if (values) {
          for (const [key1, value1] of Object.entries(values)) {
            for (const [key] of Object.entries(schema["properties"])) {
              if (key1 === key) {
                model[key1] = value1;
              }
            }
          }
        }
      }
    },
    //pushes all values to an array
    getDataDynamic() {
      let values = [];
      let title = this.title;
      if (title == "Measurements") {
        title = "Measurement";
      }
      for (const [key, value] of Object.entries(this.model)) {
        if (value != "") {
          values.push({
            Name: key,
            Value: value,
            Purpose: title,
          });
        }
      }
      if (this.showUnisex) {
        for (const [key, value] of Object.entries(this.modelUnisex)) {
          if (value != "") {
            values.push({
              Name: key,
              Value: value,
              Purpose: this.title,
            });
          }
        }
      }
      return values;
    },
    //emitted from parent when user selects Unisex gender
    //duplicate Size fields
    genderUnisex() {
      if (this.title == "Size") {
        if (this.schema.properties) {
          this.schemaUnisex["properties"] = {};
          this.schemaUnisex["type"] = "object";
          this.showUnisex = false;
          for (const [key, value] of Object.entries(this.schema.properties)) {
            this.schemaUnisex.properties[`Women's ${key}`] = {};

            this.schemaUnisex.properties[`Women's ${key}`] = Object.assign(
              this.schemaUnisex.properties[`Women's ${key}`],
              value
            );

            this.schemaUnisex.properties[`Women's ${key}`][
              "title"
            ] = `Women's ${key}`;
            this.schemaUnisex.properties["Women's " + key][
              "name"
            ] = `Women's ${key}`;
          }
          for (const [key, value] of Object.entries(this.schema.properties)) {
            this.schemaUnisex.properties[`Men's ${key}`] = {};
            this.schemaUnisex.properties[`Men's ${key}`] = Object.assign(
              this.schemaUnisex.properties[`Men's ${key}`],
              value
            );
            this.schemaUnisex.properties[`Men's ${key}`][
              "title"
            ] = `Men's ${key}`;
            this.schemaUnisex.properties[`Men's ${key}`][
              "name"
            ] = `Men's ${key}`;
          }
          this.showUnisex = true;
        }
      }
    },
    //validate fields
    //return true if validation done in registration
    //else validate fields
    validateFields() {
      if (
        this.dialogTitle == "Add new product" ||
        this.dialogTitle == "Add new variation" ||
        (this.title == "Size" &&
          this.gender == "Unisex" &&
          this.category.includes("Footwear"))
      ) {
        return true;
      } else {
        return this.$refs.form.validate();
      }
    },
  },
};
</script>